import { render, staticRenderFns } from "./ViewLayoutFloating.vue?vue&type=template&id=6f9de876"
import script from "./ViewLayoutFloating.vue?vue&type=script&lang=js"
export * from "./ViewLayoutFloating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports